import { Search, Filter ,ChevronDown} from "lucide-react";
import { useState , useEffect } from "react";
import { useNavigate } from "react-router-dom";
import  SelectOrder  from "./SelectOrder";
import DeliveryFulfillmentFlow from "./DeliveryFulfillmentFlow";
import { X,PackageX } from "lucide-react";

export default function DeliveryManager() {

  const shipments = [
    {
      shipmentId: "SHP-001",
      type: "Brickbucket",
      deliveryMode: "Own partner",
      pickups: 2,
      dropoffs: 1,
      suppliers: "-",
      customers: "-",
      distance: "24.51 km",
      eta: "2 hours",
      charge: "₹1,000",
      paidBy: "Customer",
    },
    {
      shipmentId: "SHP-002",
      type: "Supplier",
      deliveryMode: "Supplier Self",
      pickups: 1,
      dropoffs: 2,
      suppliers: "-",
      customers: "-",
      distance: "5.4 km",
      eta: "2 min",
      charge: "-",
      paidBy: "Supplier",
    },
  ];
const navigate = useNavigate();
const [openFulfillment, setOpenFulfillment] = useState(false);
const [shipmentdata,setShipmentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedShipmentId, setSelectedShipmentId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showCustomersPopup, setShowCustomersPopup] = useState(false);
const [showSuppliersPopup, setShowSuppliersPopup] = useState(false);
const [popupData, setPopupData] = useState([]);
const [showPickoffPopup, setShowPickoffPopup] = useState(false);
const [showDropoffPopup, setShowDropoffPopup] = useState(false);
const [selectedStatuses, setSelectedStatuses] = useState([]);
const [showStatusDropdown, setShowStatusDropdown] = useState(false);


const STATUS_COLORS = {
  Pending: "text-red-700 bg-red-50",
  Delivered: "text-green-700 bg-green-50",
};

const toggleStatus = (status) => {
  setSelectedStatuses((prev) =>
    prev.includes(status)
      ? prev.filter((s) => s !== status)
      : [...prev, status]
  );
};

const fetchAllDeliveryShipments = async () => {
  setLoading(true);
  try {
    const token = sessionStorage.getItem("token");

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery-shipment/get-all-delivery-shipments`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const resData = await response.json();
    const data= resData?.data || [];
    console.log("shipmentdata",data);
    setShipmentData(data);
  } catch (error) {
    console.error("Error fetching delivery shipments:", error);
    return [];
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
   fetchAllDeliveryShipments();
  }, []);

  useEffect(() => {
  const handleOutside = (e) => {
    if (!e.target.closest(".status-dropdown")) {
      setShowStatusDropdown(false);
    }
  };

  document.addEventListener("mousedown", handleOutside);
  return () => document.removeEventListener("mousedown", handleOutside);
}, []);


 

  // Function to handle view click
const handleViewClick = (shipmentId) => {
  setSelectedShipmentId(shipmentId);
  setOpenFulfillment(true);
};

const filteredShipments = shipmentdata.filter((s) => {
  const term = searchTerm.toLowerCase().trim();
  const status = s.status?.toLowerCase() || "";

  const extractNumber = (val = "") => val.replace(/\D/g, "");

  // 🔹 Detect status typed in search
  const isStatusSearch =
    term === "pending" || term === "delivered";

  // 🔍 Search match
  const searchMatch =
    !term ||
    extractNumber(s.delivery_shipment_number || "").includes(extractNumber(term)) ||
    s.delivery_type?.toLowerCase().includes(term) ||
    s.delivery_mode?.toLowerCase().includes(term) ||
    s.paid_by?.toLowerCase().includes(term) ||
    (isStatusSearch && status === term); // ⭐ IMPORTANT

  // ✅ Status filter logic
 const statusMatch =
  selectedStatuses.length === 0 ||
  selectedStatuses.includes(status);

  // 🔥 If searching status, IGNORE dropdown filter
  if (isStatusSearch) {
    return status === term;
  }

  return searchMatch && statusMatch;
});




const openCustomersPopup = (customers) => {
  setPopupData(customers || []);
  setShowCustomersPopup(true);
};

const openSuppliersPopup = (suppliers) => {
  setPopupData(suppliers || []);
  setShowSuppliersPopup(true);
};



   return (
    <>
<div className="space-y-4 pb-32 min-h-screen overflow-y-auto max-h-[80vh] p-1">
    {/* ================= DELIVERY MANAGER ================= */}
    <div className="border rounded-lg shadow-sm overflow-hidden">

      {/* Header */}
      <div className="flex flex-wrap items-center gap-3 mb-4 p-4">
        <div className="relative flex-1 min-w-[240px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
  type="text"
  placeholder="Search shipments"
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  className="w-full pl-10 pr-4 py-2 border rounded-md text-sm"
/>
        </div>

      <div className="relative status-dropdown">
  <Filter className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />

  <div
    onClick={() => setShowStatusDropdown(!showStatusDropdown)}
    className="pl-10 pr-8 py-2 border rounded-md text-sm cursor-pointer bg-white"
  >
    {selectedStatuses.length === 0
  ? "All Status"
  : `${selectedStatuses.length} Selected`}
         <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
      
  </div>

  {showStatusDropdown && (
    <div className="absolute mt-1 w-full bg-white border rounded-md shadow-md z-50 p-2 space-y-2">
      {["pending", "delivered"].map((status) => (
        <label
          key={status}
          className="flex items-center gap-2 text-sm cursor-pointer"
        >
          <input
            type="checkbox"
            checked={selectedStatuses.includes(status)}
            onChange={() => toggleStatus(status)}
          />
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </label>
      ))}
    </div>
  )}
</div>

      </div>

<div >

  {/* 📦 No data state (all shipments empty) */}
  {!loading && shipmentdata.length === 0 && (
    <div className="flex flex-col items-center justify-center min-h-[120px] px-4 border border-dashed border-gray-300 rounded-md mx-6 mb-4">
      <PackageX className="w-6 h-6 text-gray-400 mb-2" />
      <p className="text-sm text-gray-500 text-center leading-relaxed">
        Delivery shipments not found
      </p>
    </div>
  )}

  {/* ✅ Table or No search results */}
<div className="relative max-h-[26vh] overflow-y-auto overflow-x-auto">
  {/* 🔴 Loading state */}
  {loading && (
          <div className="text-center py-12 text-gray-500">Loading...</div>
  )}

  {/* ✅ Table / No Result */}
  {!loading && shipmentdata.length > 0 && (
    <table className="min-w-full table-fixed divide-y divide-gray-200">
     <thead className="bg-gray-50 sticky top-0 z-20">
        <tr>
          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Shipment ID</th>
          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Type</th>
          <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Delivery Mode</th>
          <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">Pickups</th>
          <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">DropOffs</th>
          <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">Suppliers</th>
          <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">Customers</th>
{/*           <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600">Distance</th> */}
{/*           <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600">ETA</th> */}
          <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">Delivery Charge</th>
{/*           <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600">Paid By</th> */}
          <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">Status</th>
          <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">Action</th>
        </tr>
      </thead>

      <tbody className="bg-white divide-y divide-gray-200">
        {filteredShipments.length > 0 ? (
          filteredShipments.map((s) => (
            <tr key={s._id} className="hover:bg-gray-50">
              <td className="px-4 py-3 text-sm">{s.delivery_shipment_number || "--"}</td>
              <td className="px-4 py-3 text-sm">{s.delivery_type || "--"}</td>
              <td className="px-4 py-3 text-sm">{s.delivery_mode || "--"}</td>
              <td className="px-4 py-3 text-center text-sm"
               onClick={() => setShowPickoffPopup(true)}>{s.pickups.length || "--"}</td>
              <td className="px-4 py-3 text-center text-sm"
             onClick={() => setShowDropoffPopup(true)}>{s.dropoffs.length || "--"}</td>
             <td
  className="px-4 py-3 text-center text-sm text-blue-600 cursor-pointer underline"
  onClick={() => openSuppliersPopup(s.suppliers)}
>
  {s.suppliers?.length || 0}
</td>
             <td
  className="px-4 py-3 text-center text-sm text-blue-600 cursor-pointer underline"
  onClick={() => openCustomersPopup(s.customers)}
>
  {s.customers?.length || 0}
</td>
{/*               <td className="px-4 py-3 text-center text-sm">{s.total_distance || "--"}</td> */}
{/*               <td className="px-4 py-3 text-center text-sm">{s.eta || "--"}</td> */}
              <td className="px-4 py-3 text-center text-sm">{s.estimated_delivery_charge || "--"}</td>
{/*               <td className="px-4 py-3 text-center text-sm">{s.paid_by || "--"}</td> */}
                   <td className="px-4 py-3 text-center text-sm">
                     <span
                      className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                       STATUS_COLORS[s.status] || "text-gray-600 bg-gray-100"
                      }`}
                       >
                   {s.status || "--"}
                 </span>
                 </td>
                <td className="px-4 py-3 text-center">
                <span
                  onClick={() => handleViewClick(s._id)}
                  className="inline-block cursor-pointer rounded-md border border-blue-500 px-3 py-1 text-sm text-blue-500 hover:bg-blue-50"
                >
                  View
                </span>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={12} className="text-center py-12">
              <div className="flex flex-col items-center justify-center">
                <Search className="w-6 h-6 text-gray-400 mb-2" />
                <p className="text-sm text-gray-500 text-center leading-relaxed">
                  No Result Found
                </p>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )}
</div>

</div>


    </div>

    {/* ================= GAP + SALES ORDER / SELECT ORDER ================= */}
    <div className="pt-4 pb-8">
    <SelectOrder
  onOpenFulfillment={(shipmentId) => {
    setSelectedShipmentId(shipmentId);
    setOpenFulfillment(true);
  }}
  onShipmentCreated={fetchAllDeliveryShipments}
/>
    </div>
    </div>

   {openFulfillment && (
  <div
    className="fixed top-0 left-0 w-screen h-screen z-[9999] bg-black/60"
  >
    {/* Center wrapper */}
    <div className="w-full h-full flex items-center justify-center">

      {/* POPUP CONTAINER */}
      <div className="relative w-[70vw] max-w-[1400px] h-[calc(100vh-32px)] bg-white rounded-xl shadow-2xl overflow-hidden flex">

        {/* Close Button */}
        <button
          onClick={() => setOpenFulfillment(false)}
          className="absolute top-3 right-3 z-50 p-2 rounded-full bg-white hover:bg-gray-100"
        >
          <X size={18} />
        </button>

        {/* CONTENT */}
        <div className="flex-1 min-h-0 min-w-0 overflow-hidden pt-6">
          <DeliveryFulfillmentFlow
          shipmentId={selectedShipmentId}
          showAside={false} />
        </div>

      </div>
    </div>
  </div>
)}


{showCustomersPopup && (
  <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-xl w-full max-w-3xl max-h-[80vh] overflow-auto p-6 shadow-2xl relative">
      {/* Close Button */}
      <button
        className="absolute top-4 right-4 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl border border-gray-200 hover:border-gray-300 transition-all duration-200 text-gray-600 hover:text-gray-900 hover:scale-105"
        onClick={() => setShowCustomersPopup(false)}
        aria-label="Close popup"
      >
        <X className="w-4 h-4" />
      </button>

      <h3 className="text-lg font-semibold mb-6 text-gray-900 flex-items-start">
        Customer Details
      </h3>

      {popupData.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 text-gray-500">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <p className="text-lg font-medium">No customers found</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200 text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Name</th>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Mobile</th>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Address</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {popupData.map((c, i) => (
                <tr key={c._id || i} className="hover:bg-gray-50">
                  <td className="px-4 py-2 align-top">
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-gray-900">
                        {c.name}
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-2 align-top text-gray-800">
                    {c.phone}
                  </td>
                  <td className="px-4 py-2 align-top">
                    <div className="px-3 py-2 text-xs text-blue-900">
                      {c.address || "--"}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
)}



{showSuppliersPopup && (
  <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-xl w-full max-w-3xl max-h-[80vh] overflow-auto p-6 shadow-2xl relative">
      {/* Close Button */}
      <button
        className="absolute top-4 right-4 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl border border-gray-200 hover:border-gray-300 transition-all duration-200 text-gray-600 hover:text-gray-900 hover:scale-105"
        onClick={() => setShowSuppliersPopup(false)}
        aria-label="Close popup"
      >
        <X className="w-4 h-4" />
      </button>

      <h3 className="text-lg font-semibold mb-6 text-gray-900 flex-items-start">
        Supplier Details
      </h3>

      {popupData.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 text-gray-500">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <p className="text-lg font-medium">No suppliers found</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200 text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Name</th>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Company</th>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Mobile</th>
                <th className="px-4 py-2 border-b text-left font-semibold text-gray-700">Address</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {popupData.map((s, i) => (
                <tr key={s._id || i} className="hover:bg-gray-50">
                  <td className="px-4 py-2 align-top">
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-gray-900">
                        {s.name}
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-2 align-top text-gray-800 font-medium">
                    {s.company_name}
                  </td>
                  <td className="px-4 py-2 align-top text-gray-800">
                    {s.mobile_number}
                  </td>
                  <td className="px-4 py-2 align-top">
                    <div className=" px-3 py-2 text-xs text-blue-900 max-w-xs truncate">
                      {s.address || "--"}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
)}

{showPickoffPopup && (
  <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-xl w-full max-w-lg max-h-[70vh] overflow-auto p-6 shadow-2xl relative">
      {/* Close Button */}
      <button
        className="absolute top-4 right-4 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl border border-gray-200 hover:border-gray-300 transition-all duration-200 text-gray-600 hover:text-gray-900 hover:scale-105"
        onClick={() => setShowPickoffPopup(false)}
        aria-label="Close popup"
      >
        <X className="w-4 h-4" />
      </button>

      <h3 className="text-lg font-semibold mb-6 text-gray-900">Pickoff Details</h3>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 rounded-lg">
          <thead className="bg-gray-50 border-b border-gray-300">
            <tr>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Order ID
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Items
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Quantity
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="hover:bg-gray-50">
              <td className="border border-gray-300 px-4 py-2 text-sm font-bold text-gray-800">
                OD-000123
              </td>
              <td className="border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-900">
                4
              </td>
              <td className="border border-gray-300 px-4 py-2 text-sm font-bold text-emerald-600">
                4
              </td>
            </tr>
            {/* Add more rows as needed */}
          </tbody>
        </table>
      </div>
    </div>
  </div>
)}

{showDropoffPopup && (
  <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-xl w-full max-w-lg max-h-[70vh] overflow-auto p-6 shadow-2xl relative">
      {/* Close Button */}
      <button
        className="absolute top-4 right-4 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl border border-gray-200 hover:border-gray-300 transition-all duration-200 text-gray-600 hover:text-gray-900 hover:scale-105"
        onClick={() => setShowDropoffPopup(false)}
        aria-label="Close popup"
      >
        <X className="w-4 h-4" />
      </button>

      {/* Header */}
      <h3 className="text-lg font-semibold mb-6 text-gray-900">Dropoff Details</h3>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 rounded-lg">
          <thead className="bg-gray-50 border-b border-gray-300">
            <tr>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Order ID
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase">
                Requested Items
              </th>
             
            </tr>
          </thead>
         <tbody>
            <tr className="hover:bg-gray-50">
              <td className="border border-gray-300 px-4 py-2 text-sm font-bold text-gray-800">
                OD-000123
              </td>
              <td className="border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-900">
                4
              </td>
              </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
)}



  </>
);

}


